module.exports = __webpack_public_path__ + "assets/icons/video-plus-395f.svg";